module.exports = __webpack_public_path__ + "img/PS-J-3.c6bd2311.svg";